import React, { forwardRef, HTMLProps, ReactNode } from 'react'
import clsx from 'classnames'
import { Link } from '@/routing'

export interface ButtonProps extends Omit<HTMLProps<HTMLButtonElement>, 'size' | 'prefix'> {
  color?: string
  type?: 'solid' | 'outline' | 'ghost'
  size?: 'xl' | 'l' | 'm' | 's'
  prefix?: ReactNode
  postfix?: ReactNode
  href?: string
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { className, children, color = 'blue', href, type = 'solid', size = 'm', prefix, postfix, ...restProps } = props

  if (href)
    return (
      <Link
        ref={ref as any}
        href={href}
        className={clsx(
          'text text_type_d',
          'button',
          color && `button_color_${color}`,
          type && `button_type_${type}`,
          size && `button_size_${size}`,
          className
        )}
        {...(restProps as any)}
      >
        {prefix}
        {children}
        {postfix}
      </Link>
    )

  return (
    <button
      ref={ref}
      className={clsx(
        'text text_type_d',
        'button',
        color && `button_color_${color}`,
        type && `button_type_${type}`,
        size && `button_size_${size}`,
        className
      )}
      {...restProps}
    >
      {prefix}
      {children}
      {postfix}
    </button>
  )
})

Button.displayName = 'Button'
